export const LOG_OUT = 'PROFILE/LOG_OUT';
export const SET_USER = 'PROFILE/SET_USER';
export const SET_LOADING = 'PROFILE/SET_LOADING';
export const SET_ERROR = 'PROFILE/SET_ERROR';
export const CHECKED_AUTH = 'PROFILE/CHECKED_AUTH';

export const LOGIN = 'PROFILE/LOGIN';
export const SIGN_UP = 'PROFILE/SIGN_UP';
export const RESTORE = 'PROFILE/RESTORE';
export const AUTH = 'PROFILE/AUTH';
